import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import 'react-quill-new/dist/quill.snow.css';
import App from './App';
import './index.css';
import './styles/FormSteps.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);
